import Progress from 'antd/lib/progress';
import 'antd/lib/progress/style/css';

export default Progress;
